import EditIcon from "@mui/icons-material/Edit";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ReferenceRow } from "../../types/model/reference";

interface ReferenceRowActionsProps {
  row: ReferenceRow;
  t: (key: string) => string;
  onEdit: (row: ReferenceRow) => void;
  onToggleActive: (id: number) => void;
}

export const ReferenceRowActions: React.FC<ReferenceRowActionsProps> = ({
  row,
  t,
  onEdit,
  onToggleActive,
}) => (
  <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
    <Tooltip title={t("generic.edit")}>
      <IconButton color="primary" onClick={() => onEdit(row)}>
        <EditIcon />
      </IconButton>
    </Tooltip>

    <Tooltip
      title={row.active ? t("generic.deactivate") : t("generic.activate")}
    >
      <IconButton onClick={() => onToggleActive(row.id)}>
        {row.active ? (
          <ToggleOnIcon sx={{ color: "success.main", fontSize: 28 }} />
        ) : (
          <ToggleOffIcon sx={{ color: "grey.600", fontSize: 28 }} />
        )}
      </IconButton>
    </Tooltip>
  </Box>
);
